export enum ButtonsThemes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
  SUCCESS = 'success'
}

export enum AngularButtonsThemes {
  WARN = 'warn',
  PRIMARY = 'primary',
  BASIC = 'basic',
  ACCENT = 'accent'
}
